import { fetchUtils } from 'react-admin'
import axios from 'axios'
import { stringify } from 'query-string'
import { getJWT } from '../helper/localStore/getJWT'
import { objectToQueryString } from 'src/helper/objectToQueryString'
import { HttpError } from 'react-admin'
const httpClient = fetchUtils.fetchJson

export default {
  getList: async (resource, params) => {
    const { page, perPage } = params.pagination
    const { field, order } = params.sort
    let query = {
      ordering: `${field}.${order}`,
      limit: JSON.stringify(perPage),
      skip: (page - 1) * perPage,
    }
    if(resource === 'permission'){
      if(params.filter?.entity_id){
        query['operator'] = 'equal'
      }
    }
    const filters = (params) => {
      const array = []
      Object.entries(params.filter).forEach((value, i) => {
        let [key, val] = value

        // is_active(boolean) parameters accept only numbers
        if (val === true) {
          val = 1
        } else if (val === false) {
          val = 0
        }

        array.push(`&${key}=${val}`)
      })
      const filterstostring = array.join('')
      return filterstostring
    }

    const url = `${process.env.REACT_APP_URL_AUTH}/${resource}?${stringify(query)}${filters(params)}`
    try {
      const response = await axios.get(url, {
        headers: { 'authentication-token': getJWT() },
      })
      const total = response.headers['row-counter']
      return {
        data: response.data,
        total: parseInt(total || 0),
      }
    } catch (error) {
      localStorage.removeItem(`RaStore.${resource}.listParams`)
      throw new Error('url not found')
    }
  },
  getOne: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_AUTH}/${resource}/${params.id}`, {
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({
      data: json,
    })),

  update: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_AUTH}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json })),

  create: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_AUTH}/${resource}/`, {
      method: 'POST',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({
      data: { ...params.data, id: json.id },
    })),

  getMany: (resource, params) =>
    httpClient(
      `${process.env.REACT_APP_URL_AUTH}/${resource}/?operator=or&id=${Object.values(params.ids).toString()}`,
      {
        headers: new Headers({ 'authentication-token': getJWT() }),
      }
    ).then(({ json }) => ({
      data: json,
    })),

  delete: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_AUTH}/${resource}/${params.id}`, {
      method: 'DELETE',
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json })),

  deleteMany: async (resource, params) => {
    const { json } = await httpClient(
      `${process.env.REACT_APP_URL_AUTH}/${resource}/many?${stringify({ id: params.ids })}`,
      {
        method: 'DELETE',
        headers: new Headers({ 'authentication-token': getJWT() }),
      }
    )
    return { data: json }
  },

  addUser: async (hash_user) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_AUTH}/user`, {
        body: JSON.stringify({ hash_user: hash_user }),
        headers: new Headers({ 'authentication-token': getJWT() }),
      })
    } catch (error) {}
  },

  disableOne: async (id) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_AUTH}/user/${id}`, {
        body: JSON.stringify({ is_active: false }),
        headers: new Headers({ 'authentication-token': getJWT() }),
      })
    } catch (error) {}
  },
}
